<div class="administration-container">

    <div class="administration-head d-flex align-items-center">

        <!-- ADD BUTTON -->
        <button
            class="btn btn-secondary"
            id="general-btn"
            (click)="openAddParticipant()"
        >
            {{ 'ADMINISTRATION.ADD' | translate }}&nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 18 18">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z"/>
            </svg>
        </button>

        <!-- SEARCH -->
        <div class="administration-search ms-auto">
            <input
                type="text"
                class="form-control"
                #administrationSearcher
                (input)="search()"
                placeholder="{{ 'ADMINISTRATION.SEARCH' | translate }}"
            />
        </div>

    </div>

    <!-- TABLE -->
    <div class="administration-wrapper">
        <div class="administration-body">
            <table class="table vertical-align" id="administration-table">

                <thead>
                    <th
                        (click)="sortParticipantsBy('id')"
                        id="table-header"
                        [class.asc]="sortCriteria === 'id' && sortDirection === 'asc'"
                        [class.desc]="sortCriteria === 'id' && sortDirection === 'desc'"
                    >
                        {{ 'ADMINISTRATION.ID' | translate }}
                    </th>
                    <th
                        (click)="sortParticipantsBy('name')"
                        id="table-header"
                        [class.asc]="sortCriteria === 'name' && sortDirection === 'asc'"
                        [class.desc]="sortCriteria === 'name' && sortDirection === 'desc'"
                    >
                        {{ 'ADMINISTRATION.NAME' | translate }}
                    </th>
                    <th
                        (click)="sortParticipantsBy('targetURL')"
                        id="table-header"
                        [class.asc]="sortCriteria === 'targetURL' && sortDirection === 'asc'"
                        [class.desc]="sortCriteria === 'targetURL' && sortDirection === 'desc'"
                    >
                        {{ 'ADMINISTRATION.TARGET-URL' | translate }}
                    </th>
                    <th>
                        {{ 'ADMINISTRATION.PROTOCOLS' | translate }}
                    </th>
                    <th>
                        {{ 'ADMINISTRATION.ACTIONS' | translate }}
                    </th>
                </thead>

                <tbody>
                    @for (participant of filteredParticipants; track participant) {
                        <tr>
                            <td>{{ participant.ID }}</td>
                            <td>{{ participant.name }}</td>
                            <td>{{ participant.targetURL }}</td>
                            <td>{{ participant.supportedProtocols }}</td>
                            <td class="actions-column">
								<div class="d-flex justify-content-center gap-2">
									<button type="button" class="btn" id="delete-btn" (click)="openDeleteParticipant(participant)" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-custom-class="custom-tooltip" title="{{ 'ADMINISTRATION.TOOLTIP.DELETE' | translate }}">
										<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-trash3-fill delete-icon" viewBox="0 0 16 16">
											<path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
										</svg>
									</button>
								</div>
							</td>
                        </tr>
                    }
                </tbody>
                
            </table>
        </div>
    </div>

    @if (isLoading) {
        <div class="loading-overlay">
            <div class="spinner-border"></div>
        </div>
    }

</div>

<!----------------------------- MODALS ----------------------------->

<!-- Add Participant -->

<div class="modal fade" #addParticipantModal id="addParticipantModal" tabindex="-1" aria-labelledby="addParticipantModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
	<div class="modal-dialog modal-dialog-centered modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="addParticipantModalLabel">{{ 'ADMINISTRATION.ADD' | translate }}</h5>
			</div>
			<div class="modal-body">
				<form id="addParticipantModal-form">
                    <div class="row g-4">
						<div class="col-md-12">  
							<h6 class="fw-bold mb-2">{{ 'ADMINISTRATION.PROPERTIES' | translate }}</h6>
							<div class="card shadow-sm border-0">
								<div class="card-body">
									<dl class="row">
										<div class="d-flex align-items-center mb-3">
											<dd class="col-sm-12" id="property-title">
												<label for="new-participant-id" class="form-label">
													<b>{{ 'ADMINISTRATION.ID' | translate }}</b>
												</label>
												<span id="asterisk">&nbsp;*</span>
											</dd>
										</div>
										<div class="col-12 mx-auto">
											<input type="text"
												id="new-participant-id"
												name="new-participant-id"
												class="form-control"
												[placeholder]="'ADMINISTRATION.TOOLTIP.ID' | translate"
												[(ngModel)]="newParticipantID"
											>
											@if (wrongNewParticipantIDField) {
												<div class="inputError">
													{{ 'ADMINISTRATION.ERROR.ID' | translate }}
												</div>
											}
										</div>
									</dl>
									<dl class="row">
										<div class="d-flex align-items-center mb-3">
											<dd class="col-sm-12" id="property-title">
												<label for="new-participant-name" class="form-label">
													<b>{{ 'ADMINISTRATION.NAME' | translate }}</b>
												</label>
												<span id="asterisk">&nbsp;*</span>
											</dd>
										</div>
										<div class="col-12 mx-auto">
											<input type="text"
												id="new-participant-name"
												name="new-participant-name"
												class="form-control"
												[placeholder]="'ADMINISTRATION.TOOLTIP.NAME' | translate"
												[(ngModel)]="newParticipantName"
											>
											@if (wrongNewParticipantNameField) {
												<div class="inputError">
													{{ 'ADMINISTRATION.ERROR.NAME' | translate }}
												</div>
											}
										</div>
									</dl>
									<dl class="row">
										<div class="d-flex align-items-center mb-3">
											<dd class="col-sm-12" id="property-title">
												<label for="new-participant-target-url" class="form-label">
													<b>{{ 'ADMINISTRATION.TARGET-URL' | translate }}</b>
												</label>
												<span id="asterisk">&nbsp;*</span>
											</dd>
										</div>
										<div class="col-12 mx-auto">
											<input type="text"
												id="new-participant-target-url"
												name="new-participant-target-url"
												class="form-control"
												[placeholder]="'ADMINISTRATION.TOOLTIP.TARGET-URL' | translate"
												[(ngModel)]="newParticipantTargetURL"
											>
											@if (wrongNewParticipantTargetURLField) {
												<div class="inputError">
													{{ 'ADMINISTRATION.ERROR.TARGET-URL' | translate }}
												</div>
											}
										</div>
									</dl>
									<dl class="row">
										<div class="d-flex align-items-center mb-3">
											<dd class="col-sm-12" id="property-title">
												<label for="new-participant-protocols" class="form-label">
													<b>{{ 'ADMINISTRATION.PROTOCOLS' | translate }}</b>
												</label>
												<span id="asterisk">&nbsp;*</span>
											</dd>
										</div>
										<div class="col-12 mx-auto">
											<div class="multi-select">
												<div class="multi-select-header" (click)="toggleDropdown()">
													{{ newParticipantProtocols.join(', ') || 'ADMINISTRATION.TOOLTIP.PROTOCOL' | translate }}
													<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
														<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
													</svg>
												</div>
												@if (showProtocolsDropdown) {
													<div class="multi-select-dropdown">
														@for (protocol of protocols; track protocol) {
															<div
																class="multi-select-option"
																(click)="toggleProtocol(protocol)"
															>
															<input
																type="checkbox"
																[checked]="isSelected(protocol)"
																(change)="toggleProtocol(protocol)"
															/>
																{{ protocol | translate }}
															</div>
														}
													</div>
												}
												@if (wrongNewParticipantProtocolsField) {
													<div class="inputError">
														{{ 'ADMINISTRATION.ERROR.PROTOCOLS' | translate }}
													</div>
												}
											</div>
										</div>
									</dl>
								</div>
							</div>
						</div>
					</div>
                </form>
            </div>
            <div class="modal-footer" style="margin-top: 10px;">
				<button type="button" class="btn btn-secondary"(click)="cancelAddParticipant()">{{ 'ADMINISTRATION.CANCEL' | translate }}</button>
				<button type="button" class="btn btn-primary" id="addParticipantBtn" (click)="addParticipant()">{{ 'ADMINISTRATION.ADD-SHORT' | translate }}</button>
			</div>
        </div>
    </div>
</div>

<!-- Delete Participant -->

<div class="modal fade" #deleteParticipantModal id="deleteParticipantModal" tabindex="-1" aria-labelledby="deleteParticipantModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
	<div class="modal-dialog modal-dialog-centered modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="deleteParticipantModalLabel">{{ 'ADMINISTRATION.DELETE' | translate }}</h5>
			</div>
			<div class="modal-body">
				<form id="deleteParticipantModal-form">
                    <div class="row g-4">
						<div class="col-md-12">  
							<div class="card shadow-sm border-0">
								<div class="card-body">
									<dl class="row">
										<h5 class="delete-title">
											{{ 'ADMINISTRATION.CONFIRMATION' | translate }}
										</h5>
										<table id="delete-participant-table">
											<thead>
												<th>
													{{ 'ADMINISTRATION.ID' | translate }}
												</th>
												<th>
													{{ 'ADMINISTRATION.NAME' | translate }}
												</th>
												<th>
													{{ 'ADMINISTRATION.TARGET-URL' | translate }}
												</th>
												<th>
													{{ 'ADMINISTRATION.PROTOCOLS' | translate }}
												</th>
											</thead>
											<tbody>
												@if (selectedParticipant) {
													<tr>
														<td>
															{{ selectedParticipant.ID }}
														</td>
														<td>
															{{ selectedParticipant.name }}
														</td>
														<td 
															title="{{ selectedParticipant.targetURL }}" 
															style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 30ch;"
														>
															{{ selectedParticipant.targetURL.substring(0, 30) }}{{ selectedParticipant.targetURL.length > 30 ? '...' : '' }}
														</td>
														<td>
															{{ selectedParticipant.supportedProtocols }}
														</td>
													</tr>
												}
											</tbody>
										</table>
									</dl>
								</div>
							</div>
						</div>
					</div>
                </form>
            </div>
            <div class="modal-footer" style="margin-top: 10px;">
				<button type="button" class="btn btn-secondary"(click)="cancelDeleteParticipant()">{{ 'ADMINISTRATION.CANCEL' | translate }}</button>
				<button type="button" class="btn btn-primary" id="deleteParticipantBtn" (click)="deleteParticipant()">{{ 'ADMINISTRATION.DELETE-SHORT' | translate }}</button>
			</div>
        </div>
    </div>
</div>

<!-- Toast -->

<div class="toast-container position-fixed top-0 end-0 p-3">
	<div
		#toastElement
		class="toast align-items-center text-bg-success border-0"
		role="alert"
		aria-live="assertive"
		aria-atomic="true"
	>
		<div class="d-flex">
			<div class="toast-body">
				{{ toastMessage }}
			</div>
			<button
				type="button"
				class="btn-close btn-close-white me-2 m-auto"
				data-bs-dismiss="toast"
				aria-label="Close">
			</button>
		</div>
	</div>
</div>